import React, { Component } from 'react';
import Helmet from 'react-helmet';
import translate from './TranslateHOC';
import {
  PAGE_TITLE,
  PAGE_TITLE_SEPARATOR,
  META_DEFAULT_IMAGE,
  META_DESCRIPTION_MAX_CHAR,
} from '../constants';
import { truncateStr, decodeHtml } from '../helpers';

class PageMeta extends Component {
  render() {
    const { strings, title, socialTitle, description } = this.props;
    const metaTitle =
      title && title.length > 0
        ? `${title} ${PAGE_TITLE_SEPARATOR} ${PAGE_TITLE}`
        : `${PAGE_TITLE}`;
    const metaDescription =
      description && description.length > 0
        ? decodeHtml(truncateStr(description, META_DESCRIPTION_MAX_CHAR))
        : decodeHtml(
            truncateStr(strings.metaDescription, META_DESCRIPTION_MAX_CHAR)
          );
    return (
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription}></meta>

        <meta property="og:site_name" content={strings.metaTitle} />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={socialTitle ? socialTitle : strings.metaTitle}
        />
        <meta property="og:url" content={strings.metaUrl} />
        <meta
          property="og:description"
          content={metaDescription ? metaDescription : strings.metaDescription}
        />
        <meta
          property="og:image"
          content={`https://www.s4c.co.uk/amg/1920x1080/${META_DEFAULT_IMAGE}`}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content={strings.metaTwitter} />
        <meta
          name="twitter:title"
          content={socialTitle ? socialTitle : strings.metaTitle}
        />
        <meta name="twitter:url" content={strings.metaUrl} />
        <meta
          name="twitter:image"
          content={`https://www.s4c.co.uk/amg/1920x1080/${META_DEFAULT_IMAGE}`}
        />
        <meta name="twitter:image:alt" content={strings.metaTitle} />
        <meta
          name="twitter:description"
          content={metaDescription ? metaDescription : strings.metaDescription}
        />
      </Helmet>
    );
  }
}

export default translate(PageMeta);
